export enum FinalidadeNFeEnum {
    Normal = 1,
    Complementar = 2,
    Ajuste = 3,
    Devolucao = 4,
}
